import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import TableLayout from '../../../components/common/Table';
import SearchFilters from '../../../components/elements/SearchFilter';
import { postAsync } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../shared/Helper';
import { printTable } from '../../../utils/tableExportUtils';
const GetEPUserProfileReport = () => {
  const [datanotfound, setDatanotfound] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [apiData, setApiData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [applicantName, setApplicantName] = useState([]);
  const [selectapplicantName, setSelectapplicantName] = useState(null);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [next, setNext] = useState(1);
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();

  useEffect(() => {
    EPUserProfileReportList();
    GetApplicantName();
  }, []);
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const SearchFilter = {
    epUsername: selectapplicantName || '',
  };

  const columnsData = ['sNo', 'Username', 'Full Name', 'Country', 'Hit Count'];

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.userName || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.fullName || 'N/A'}</Table.Cell>
        <Table.Cell>{!isActive ? data?.en_US : data?.ar_SA || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.hitCount || '0'}</Table.Cell>
      </Table.Row>
    );
  });

  // const EPUserProfileReportList = async () => {
  //   setIsLoad(true);
  //   const response = await postAsync(
  //     `EP_UserAuthentication/GetEPUserprofilereport/${pageOptions.pageNo}/${pageOptions.pageSize}`,
  //     SearchFilter,
  //   );

  //   if (response) {
  //     setIsLoad(false);
  //     setApiData(response?.data);
  //     setPageCount(response.page);
  //     setNext(1);
  //   }
  //   if (response?.statusCode == 204) {
  //     setDatanotfound(true);
  //   }
  // };

  const EPUserProfileReportList = async () => {
    try {
      setIsLoad(true);
      const response = await postAsync(
        `EP_UserAuthentication/GetEPUserprofilereport/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );

      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setDatanotfound(false);
        setNext(1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (error) {
      setIsLoad(false);
      setDatanotfound(true);
    }
  };
  const GetApplicantName = async () => {
    const response = await postAsync(`EP_UserAuthentication/GetEPUserprofilereport/${pageOptions.pageNo}/1000`, {
      EPUsername: '',
    });

    if (response) {
      const uniqueResult = response?.data.filter(
        (item, index, self) => index === self.findIndex((t) => t.userName === item.userName),
      );
      setApplicantName(uniqueResult);
    }
  };
  const changePage = async ({ selected }) => {
    const newPage = selected + 1;

    try {
      setIsLoad(true);
      const response = await postAsync(
        `EP_UserAuthentication/GetEPUserprofilereport/${newPage}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(selected + 1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(`${t('msg_errorDueto')}: ${err.message}`);
    }
  };
  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   // Create a container for the table
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('User Profile Report List')}`;
  //   tableContainer.appendChild(heading);

  //   // Create the table
  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Username`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Full Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Country`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Hit Count`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //       <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //         <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.userName}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.fullName}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.ar_SA : data?.en_US || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.hitCount}</td>

  //       </tr>
  //     `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS for print styling
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {
  //    body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }

  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog after a small delay to ensure styles are applied
  //   setTimeout(() => {
  //     window.print();

  //     // Clean up by removing the table container and style from the DOM
  //     document.body.removeChild(tableContainer);
  //     document.head.removeChild(style);

  //     // Revert display of other elements after printing
  //     setTimeout(() => {
  //       document.querySelectorAll('body > *').forEach((el) => {
  //         el.style.display = 'block';
  //       });
  //     }, 100); // Adjust delay as needed
  //   }, 500); // Adjust delay as needed

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Username'),
      accessor: (row) => isActive ? row?.userName : row?.userName
    },
     {
      header: t('Full Name'),
      accessor: (row) => isActive ? row?.fullName: row?.fullName
    },   {
      header: t('Country'),
      accessor: (row) => isActive ? row?.ar_SA  || 'N/A' : row?.en_US  || 'N/A'
    },   {
      header: t('Hit Count'),
      accessor: (row) => isActive ? row?.hitCount  || 'N/A' : row?.hitCount || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Press Release List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  const handleSearch = async () => {
    setApiData([]);
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      // `ServiceForYou/GetServiceForYouReportFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
      `EP_UserAuthentication/GetEPUserprofilereport/${pageOptions.pageNo}/${pageOptions.pageSize}`,
      SearchFilter,
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnExport = () => {
    const keysArray = [t('S.No'), t('Username'), t('Full Name'), t('Country'), t('Hit Count')];
    const filteredData = apiData?.map((item, ii) => ({
      [keysArray[0]]: ii + 1,
      [keysArray[1]]: item.userName,
      [keysArray[2]]: item.fullName || 'N/A',
      [keysArray[3]]: isActive ? item?.ar_SA : item?.en_US || 'N/A',
      [keysArray[4]]: item?.hitCount,
    }));
    downloadCSV(filteredData, 'User Profile Report List');
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row justify-center py-5 mt-3">
          <SearchFilters
            handleSearch={handleSearch}
            setDateFrom={setDateFrom}
            setDateTo={setDateTo}
            dateTo={dateTo}
            dateFrom={dateFrom}
            handlePrint={handlePrint}
            handleOnExport={handleOnExport}
            applicantName={applicantName}
            setSelectapplicantName={setSelectapplicantName}
            type="reportList"
            heading={'User Profile Report List'}
          />
        </div>
        <div className="row justify-center">
          <TableLayout
            columns={columnsData}
            data={apiData}
            datanotfound={datanotfound}
            pageCount={pageCount}
            changePage={changePage}
            isLoad={isLoad}
            next={next}
            pageOptions={pageOptions}
            displayRecords={displayRecords}
          />
        </div>
      </div>
    </>
  );
};

export default GetEPUserProfileReport;
